import { render, staticRenderFns } from "./Registered.vue?vue&type=template&id=35e1e843&scoped=true&"
import script from "./Registered.vue?vue&type=script&lang=js&"
export * from "./Registered.vue?vue&type=script&lang=js&"
import style0 from "./Registered.vue?vue&type=style&index=0&id=35e1e843&prod&lang=scss&"
import style1 from "./Registered.vue?vue&type=style&index=1&id=35e1e843&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e1e843",
  null
  
)

export default component.exports